import React from "react";
import Modal from "@material-ui/core/Modal";

import "./DeleteConfirmModal.css";

function DeleteConfirmModal({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  loading = false,
}) {
  return (
    <Modal
      open={open}
      onClose={loading ? undefined : onCancel}
      aria-labelledby="delete-confirm-title"
    >
      <div
        className="delete-confirm-modal"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="delete-confirm-title">{title}</h2>
        <p>{message}</p>
        <div className="delete-confirm-modal__actions">
          <button
            type="button"
            className="btn btn-default"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={onConfirm}
            disabled={loading}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default DeleteConfirmModal;
